import { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import Menu from './Menu/Menu';
import './HomeLayout.scss';
import { useAppDispatch, useAppSelector } from '@hooks';
import { setIsFinalApproveSettingState } from '@redux/reducers/appSlice';
import { getSettingFindByKeyAsync } from '@redux/actions/apiActions/settingApiAction';
import { USER_ROLE } from '@utils/constants/enums';
import { getNotificationUnconfirmedCountAsync } from '@redux/actions/apiActions/notificationApiAction';

const HomeLayout: FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.auth);

  useEffect(() => {
    dispatch(getNotificationUnconfirmedCountAsync());
  }, [dispatch]);

  useEffect(() => {
    if (
      user.role !== USER_ROLE.RECEPTIONIST &&
      user.role !== USER_ROLE.MANAGER
    ) {
      getSettingFindByKey();
    }
  }, []);

  const getSettingFindByKey = async () => {
    try {
      const result = await dispatch(getSettingFindByKeyAsync()).unwrap();
      dispatch(setIsFinalApproveSettingState(result.value));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className='HomeLayout'>
      <div className='HomeLayout__container'>
        <Header />
        <div className='HomeLayoutBody'>
          <Menu />
          <div className='HomeLayoutBody__content'>
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default HomeLayout;
